import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLocation } from "@/lib/locations";

export const BlogFAQ = ({ lang = 'en' }: { lang?: 'en' | 'es' | 'ru' | 'zh' }) => {
  const location = useLocation();

  const getFaqs = () => {
    if (lang === 'es') {
      return [
        {
          question: `¿Vale la pena contratar un limpiador profesional en ${location.name}?`,
          answer: `¡Sí! Contratar a un limpiador profesional le ahorra horas de tiempo cada semana, reduce el estrés y asegura que su hogar mantenga un nivel más alto de higiene. Para familias ocupadas y profesionales en ${location.name}, el tiempo ahorrado por sí solo a menudo supera el costo.`
        },
        {
          question: `¿Qué debo buscar al elegir un servicio de limpieza en ${location.name}?`,
          answer: `Siempre busque una empresa que esté completamente asegurada, realice rigurosas verificaciones de antecedentes de su personal, ofrezca precios fijos transparentes y respalde su trabajo con una garantía de satisfacción. Evite servicios con tarifas ocultas o aquellos que requieren presupuestos en el hogar antes de proporcionar un precio.`
        },
        {
          question: `¿Con qué frecuencia la mayoría de las personas en ${location.name} limpian su casa?`,
          answer: `La mayoría de nuestros clientes en ${location.name} eligen la limpieza quincenal (cada dos semanas). Esto logra el equilibrio perfecto entre mantener un hogar consistentemente limpio y administrar un presupuesto. Los hogares ocupados con niños o mascotas a menudo prefieren la limpieza semanal.`
        },
        {
          question: `¿Necesito limpiar antes de que lleguen los limpiadores?`,
          answer: `¡Para nada! Sin embargo, recomendamos recoger el desorden suelto (como ropa, juguetes o papeles) de los pisos y mostradores. Esto permite que su equipo de limpieza concentre su tiempo en la limpieza profunda de las superficies en lugar de organizar sus pertenencias.`
        },
        {
          question: `¿Cuál es la diferencia entre una limpieza regular y una limpieza profunda?`,
          answer: `Una limpieza regular cubre el mantenimiento de rutina como quitar el polvo, aspirar, trapear y limpiar baños y cocinas. Una limpieza profunda incluye todo en una limpieza regular, además de la limpieza detallada a mano de zócalos, puertas, persianas y el interior de los electrodomésticos. Recomendamos encarecidamente una limpieza profunda para su primera visita.`
        }
      ];
    }
    
    if (lang === 'ru') {
      return [
        {
          question: `Стоит ли нанимать профессионального уборщика в ${location.name}?`,
          answer: `Да! Наем профессионального уборщика экономит вам часы времени каждую неделю, снижает стресс и гарантирует, что ваш дом поддерживает более высокий уровень гигиены. Для занятых семей и профессионалов в ${location.name} сэкономленное время часто перевешивает стоимость.`
        },
        {
          question: `На что следует обратить внимание при выборе клининговой службы в ${location.name}?`,
          answer: `Всегда ищите компанию, которая полностью застрахована, проводит строгую проверку биографических данных своих сотрудников, предлагает прозрачные фиксированные цены и подкрепляет свою работу гарантией удовлетворенности. Избегайте услуг со скрытыми платежами или тех, которые требуют оценки на дому перед предоставлением цены.`
        },
        {
          question: `Как часто большинство людей в ${location.name} убирают свой дом?`,
          answer: `Большинство наших клиентов в ${location.name} выбирают уборку раз в две недели. Это обеспечивает идеальный баланс между поддержанием стабильно чистого дома и управлением бюджетом. Занятые семьи с детьми или домашними животными часто предпочитают еженедельную уборку.`
        },
        {
          question: `Нужно ли мне убираться до прихода уборщиков?`,
          answer: `Вовсе нет! Тем не менее, мы рекомендуем убрать разбросанные вещи (например, одежду, игрушки или бумаги) с полов и столешниц. Это позволит вашей клининговой команде сосредоточить свое время на глубокой очистке поверхностей, а не на организации ваших вещей.`
        },
        {
          question: `В чем разница между обычной и генеральной уборкой?`,
          answer: `Обычная уборка включает в себя регулярное обслуживание, такое как удаление пыли, уборка пылесосом, мытье полов, а также уборка ванных комнат и кухонь. Генеральная уборка включает в себя все то же самое, что и обычная уборка, плюс детальное ручное протирание плинтусов, дверей, жалюзи и внутренней части бытовой техники. Мы настоятельно рекомендуем генеральную уборку для вашего первого визита.`
        }
      ];
    }
    
    if (lang === 'zh') {
      return [
        {
          question: `在${location.name}聘请专业房屋清洁工值得吗？`,
          answer: `值得！聘请专业房屋清洁工每周可以为您节省数小时的时间，减轻压力，并确保您的家保持更高的卫生标准。对于${location.name}的忙碌家庭和专业人士来说，仅节省的时间通常就超过了成本。`
        },
        {
          question: `在${location.name}选择清洁服务时应该注意什么？`,
          answer: `始终寻找一家拥有全面保险、对其员工进行严格背景调查、提供透明统一价格，并以满意度保证支持其工作的公司。避免有隐藏费用的服务或在提供价格之前需要上门估价的服务。`
        },
        {
          question: `在${location.name}，大多数人多久打扫一次房子？`,
          answer: `我们在${location.name}的大多数客户选择每两周（每两周）清洁一次。这在保持房屋始终清洁和管理预算之间取得了完美的平衡。有孩子或宠物的忙碌家庭通常更喜欢每周清洁一次。`
        },
        {
          question: `清洁工到达之前我需要打扫吗？`,
          answer: `完全不需要！但是，我们建议捡起地板和柜台上的散乱杂物（如衣服、玩具或文件）。这使您的清洁团队能够将时间集中在深度清洁表面上，而不是整理您的物品。`
        },
        {
          question: `定期清洁和深度清洁有什么区别？`,
          answer: `定期清洁包括日常维护，如除尘、吸尘、拖地以及清洁浴室和厨房。深度清洁包括定期清洁中的所有内容，加上对踢脚线、门、百叶窗和电器内部的详细手工擦拭。我们强烈建议您在第一次访问时进行深度清洁。`
        }
      ];
    }

    return [
      {
        question: `Is hiring a professional house cleaner in ${location.name} worth the cost?`,
        answer: `Yes! Hiring a professional house cleaner saves you hours of time each week, reduces stress, and ensures your home maintains a higher standard of hygiene. For busy families and professionals in ${location.name}, the time saved alone often outweighs the cost.`
      },
      {
        question: `What should I look for when choosing a cleaning service in ${location.name}?`,
        answer: `Always look for a company that is fully insured, performs rigorous background checks on their staff, offers transparent flat-rate pricing, and backs their work with a satisfaction guarantee. Avoid services with hidden fees or those that require in-home estimates before providing a price.`
      },
      {
        question: `How often do most people in ${location.name} have their house cleaned?`,
        answer: `The majority of our clients in ${location.name} choose bi-weekly (every two weeks) cleaning. This strikes the perfect balance between maintaining a consistently clean home and managing a budget. Busy households with kids or pets often prefer weekly cleaning.`
      },
      {
        question: `Do I need to clean before the cleaners arrive?`,
        answer: `Not at all! However, we do recommend picking up loose clutter (like clothes, toys, or paperwork) off the floors and counters. This allows your cleaning team to focus their time on deep cleaning surfaces rather than organizing your belongings.`
      },
      {
        question: `What is the difference between a regular clean and a deep clean?`,
        answer: `A regular clean covers routine maintenance like dusting, vacuuming, mopping, and cleaning bathrooms and kitchens. A deep clean includes everything in a regular clean, plus detailed hand-wiping of baseboards, doors, blinds, and inside appliances. We highly recommend a deep clean for your first visit.`
      }
    ];
  };

  const faqs = getFaqs();
  
  const title = lang === 'es' ? `Preguntas frecuentes sobre limpieza en ${location.name}` :
                lang === 'ru' ? `Часто задаваемые вопросы по уборке в ${location.name}` :
                lang === 'zh' ? `${location.name} 的相关清洁常见问题` :
                `Related Cleaning FAQs for ${location.name}`;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };

  return (
    <div className="mt-16 pt-12 border-t">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <h3 className="text-2xl font-bold mb-8">{title}</h3>
      <Accordion type="single" collapsible className="w-full space-y-4">
        {faqs.map((faq, i) => (
          <AccordionItem key={i} value={`blog-faq-${i}`} className="bg-card px-6 rounded-xl border shadow-sm">
            <AccordionTrigger className="text-left font-bold py-6 hover:no-underline">
              <span className="flex gap-4">
                <span className="text-primary">{i + 1}.</span>
                {faq.question}
              </span>
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground leading-relaxed pb-6 pl-8">
              {faq.answer}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
